import {h, Fragment} from "preact"
import { useAppState, useFacets, useProductFilters, useSelectedFiltersCount } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import SelectedFilters from "./SelectedFilters"
import { useEffect } from "preact/hooks"

// function ToggleSidebarButton({ className }) {
//     return (
//         <label
//             className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
//             for="toggle-mobile-sidebar"
//         >
//             <Icon name="close" />
//         </label>
//     )
// }

export default function Sidebar({ isVisible, onToggle }) {
    const { loading, facets } = useFacets();
    const { filters, removeAll } = useProductFilters()
    const selectedFiltersCount = useSelectedFiltersCount() - filters?.filter(filter => filter.name === 'Tags - Hidden').length
    const { query, response, pageType } = useAppState()

    const docCount = new Intl.NumberFormat('en-en').format( response.products?.total ) ?? 0

    useEffect(() => {
        const handleBodyScroll = () => {
            if (isVisible && window.innerWidth <= 768) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "";
            }
        };

        handleBodyScroll();

        window.addEventListener("resize", handleBodyScroll);

        return () => {
            document.body.style.overflow = "";
            window.removeEventListener("resize", handleBodyScroll);
        };
    }, [isVisible]);

    return facets?.length > 0 ? (
        <>
            <div
                class={`ns-sidebar-container ${isVisible ? "ns-menu-show" : "ns-menu-hide"}`}
                style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-selected-filters-d">
                    <SelectedFilters />
                </div>
                <div class="ns-sidebar-m-header">
                    <span onClick={onToggle}>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1.14922L15.8507 16" stroke="#393d3c" stroke-width="1.6" stroke-linecap="round" />
                            <path d="M1 15.8507L15.8507 0.999951" stroke="#393d3c" stroke-width="1.6" stroke-linecap="round" />
                        </svg>
                    </span>
                </div>
                <div class="ns-sidebar-menu">
                    <ul class="ns-facet-list">
                        {facets.map((facet) => {
                            if(facet.name.toLowerCase().includes("hidden")) return;
                            switch (facet.type) {
                                case "terms":
                                    return <Facet key={facet.id} facet={facet} />;
                                case "stats":
                                    return <RangeFacet key={facet.id} facet={facet} />;
                                default:
                                    return null;
                            }
                        })}
                    </ul>
                </div>
                <div class="ns-sidebar-m-footer">
                   {selectedFiltersCount > 0 ? ( 
                   <>
                        <button onClick={onToggle} class="ns-sidebar-blue-button">See {docCount} results</button>
                        <a
                            href="javascript:void(0)"
                            class="ns-clear-filters-link"
                            onClick={() => {
                                removeAll()
                            }}
                        >
                            Clear All
                        </a>
                    </>
                    ) : (
                   <button class="ns-sidebar-gray-button">Select filters</button>)}
                    
                </div>
            </div>
            {isVisible && <div onClick={onToggle} class="ns-dark-overlay"></div>}
        </>
    ) : null;
}

